/**
 * @generated SignedSource<<d9d40b1f442f85a2e301268f144cd19e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type userCreateUploadPhotoSignedUrlMutation$variables = {
  filesize: number;
};
export type userCreateUploadPhotoSignedUrlMutation$data = {
  readonly createUploadPhotoSignedUrl: {
    readonly signedUrl: string;
    readonly photoUrl: string;
  };
};
export type userCreateUploadPhotoSignedUrlMutation = {
  variables: userCreateUploadPhotoSignedUrlMutation$variables;
  response: userCreateUploadPhotoSignedUrlMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filesize"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filesize",
        "variableName": "filesize"
      }
    ],
    "concreteType": "UploadPhotoSignedUrlPayload",
    "kind": "LinkedField",
    "name": "createUploadPhotoSignedUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signedUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "photoUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userCreateUploadPhotoSignedUrlMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userCreateUploadPhotoSignedUrlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5fa4011ef0671840f36a5d60b973eb52",
    "id": null,
    "metadata": {},
    "name": "userCreateUploadPhotoSignedUrlMutation",
    "operationKind": "mutation",
    "text": "mutation userCreateUploadPhotoSignedUrlMutation(\n  $filesize: Int!\n) {\n  createUploadPhotoSignedUrl(filesize: $filesize) {\n    signedUrl\n    photoUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "188d1b4cd0bb81545f37bb6a534d73aa";

export default node;
